<template>
  <a
    :href="href"
    :data-env="envVariant"
    :class="classes"
    :title="logoTitle"
    rel="noopener"
    @click="onClick"
  >
    <component
      :is="logoVariant"
      class="logo__icon"
      role="img"
      :data-test-id="`logo-icon${variant !== 'color' ? `-${variant}` : ''}`"
    />
  </a>
</template>

<script>
import upperFirst from 'lodash/upperFirst';
import classes from '~~/common/vue/mixins/classes';
import ELogoColor from '~~/common/vue/components/logos/logo-ecosia.svg';
import ELogoCompact from '~~/common/vue/components/logos/logo-compact.svg';
import ELogoTransitional from '~~/common/vue/components/logos/logo-transitional.svg';
import { sendCoreAnalyticsEvent } from '~~/common/js/client/analytics';

export const variants = ['color', 'compact', 'transitional'];

export default {
  name: 'ELogo',
  components: {
    ELogoColor,
    ELogoCompact,
    ELogoTransitional,
  },
  mixins: [classes],
  props: {
    href: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'color',
      validator: (variant) => variants.includes(variant),
      cssClass: true,
    },
    // TODO: remove this when paddings are applied per-use-case base
    padding: {
      type: Boolean,
      default: true,
      cssClass: true,
    },
    showEnvironment: {
      type: Boolean,
      default: false,
      cssClass: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    envVariant() {
      if (this.$config.isProd) {
        return false;
      }
      return this.$config.environment;
    },
    logoTitle() {
      return this.title || this.$t('common.logo.titletag');
    },
    logoVariant() {
      return `ELogo${upperFirst(this.variant)}`;
    },
  },
  methods: {
    onClick() {
      sendCoreAnalyticsEvent('logoClicked', {
        href: this.href,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: block;
  color: var(--color-brand-primary);
  position: relative;
}

.logo__icon {
  max-width: 100%;
  height: 100%;
}

.logo--padding {
  .logo__icon {
    padding: $space-1s;
  }
}

.logo--show-environment::after {
  @include desktop {
    content: attr(data-env);
    text-transform: uppercase;
    position: absolute;
    font-size: $font-1s;
    top: -$space-s;
    left: 0;
    opacity: $opacity-m;
    font-weight: bold;
    color: var(--color-brand-primary);
    transition: opacity $timing-2s $easing;
  }
}

.logo--show-environment:hover::after {
  opacity: $opacity-1l;
}

.logo--compact::after {
  content: none;
}
</style>
